// extracted by mini-css-extract-plugin
export default {"zoomModal":"D0-z"};